import SectionLabel from "@/components/base/SectionLabel";
import { approachData } from "@/mocks/homeData";

export default function PhilosophySection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-start">
          {/* Left: Text */}
          <div className="reveal">
            <SectionLabel label={approachData.label} className="mb-3" />
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5 md:mb-6">
              {approachData.title}
            </h2>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              {approachData.intro}
            </p>
          </div>

          {/* Right: Points */}
          <div className="space-y-5 md:space-y-6">
            {approachData.points.map((point, idx) => (
              <div
                key={point.num}
                className="reveal flex gap-4 md:gap-5 items-start"
                style={{ transitionDelay: `${idx * 120}ms` }}
              >
                <span className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm md:text-base font-bold font-heading">
                  {point.num}
                </span>
                <div>
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-1 font-heading">
                    {point.title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {point.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}